import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../layout/Layout';
const HomePage = () => {
  const [userData, setUserData] = useState({});
  const location = useLocation();
  const authToken = location.state && location.state.authToken;

  useEffect(() => {
    if (authToken) {
      fetch('https://dummyjson.com/auth/me', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      })
        .then(res => res.json())
        .then(data => {
          setUserData(data);
          console.log('User Data:', data);
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
        });
    }
  }, [authToken]);

  return <Layout userData={userData} />;
};

export default HomePage;
